import { useState } from "react";
import { FaEdit } from "react-icons/fa";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import {
  useAddOutletTypesModule,
  useOutletTypeModuleList,
  useUpdateOutletTypeModule,
} from "./hooks/useSettingsMasters";
import { useLocation } from "react-router-dom";

type Props = {};

function OutletModuleType({}: Props) {
  const location = useLocation();
  const { outletTypeId } = location.state || {};
  const [isOpenModal, setIsModalOpen] = useState(false);
  const [modalStatus, setModalStatus] = useState("");
  const [moduleName, setModuleName] = useState("");
  const [moduleTypeId, setModuleTypeId] = useState("");
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
  });

  const { data: outletTypeModule } = useOutletTypeModuleList({
    id: outletTypeId,
    params: {
      search: filtersState?.search,
      start: filtersState?.page,
      length: filtersState?.limit,
      sortColumn: "CreatedAt",
      sortOrder: "DESC",
    },
    enable: true,
  });

  const { mutate: addOutletTypeModule } = useAddOutletTypesModule();
  const { mutate: updateOutletTypeModule } = useUpdateOutletTypeModule();

  const handleEditOutletModuleType = (row: any) => {
    setModalStatus("Edit");
    setIsModalOpen(true);
    setModuleTypeId(row?.Outlettypemoduleid);
    setModuleName(row?.ModuleName);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setModalStatus("");
    setModuleName("");
    setModuleTypeId("");
  };

  const toggleModal = () => {
    setIsModalOpen(false);
    setModalStatus("");
    setModuleName("");
    setModuleTypeId("");
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleAddAnnouncements = () => {
    setModalStatus("Add");
    setIsModalOpen(true);
  };

  const handleClick = () => {
    if (modalStatus === "Edit") {
      const updateOutletTypeModuleBody = {
        Outlettypeid: outletTypeId,
        ModuleName: moduleName,
      };
      updateOutletTypeModule(
        { id: moduleTypeId, body: updateOutletTypeModuleBody },
        {
          onSuccess: () => {
            handleClose();
          },
          onSettled: () => {
            handleClose();
          },
        }
      );
    } else {
      const addOutletTypeModuleBody = {
        Outlettypeid: outletTypeId,
        ModuleName: moduleName,
      };

      addOutletTypeModule(addOutletTypeModuleBody, {
        onSuccess: () => {
          handleClose();
        },
        onSettled: () => {
          handleClose();
        },
      });
    }
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Outlet Type Module"
        buttons={[
          {
            label: "+ Add Outlet Type Module",
            onClick: () => handleAddAnnouncements(),
            color: "#43B9B2",
          },
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
        ]}
      />

      {/* Table with Filters */}
      <BasicDataTable
        Title="Outlet Types Module"
        data={outletTypeModule?.data?.data || []}
        columns={outletModuleTypeColumns(handleEditOutletModuleType)}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={outletTypeModule?.data?.recordsTotal || 0}
      />
      <RouteModal
        size="sm"
        toggle={toggleModal}
        isOpen={isOpenModal}
        title={
          modalStatus === "Edit"
            ? "Edit Outlet Type Module"
            : "Add Outlet Type Module"
        }
        content={
          <>
            <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
              <CustomInput
                label="Module Name"
                type="text"
                value={moduleName}
                style={{
                  backgroundColor: "transparent",
                  border: "0.2px solid #d4d4d4",
                  flex: 1,
                }}
                onChange={(e) => setModuleName(e.target.value)}
              />
            </div>
            <div style={{ marginTop: "20px" }}>
              <button onClick={handleClick} className="btn btn-primary">
                {modalStatus === "Edit" ? "Update" : "Submit"}
              </button>
              <button
                onClick={handleClose}
                className="btn btn-light"
                style={{ color: "gray", marginLeft: "10px" }}
              >
                Cancel
              </button>
            </div>
          </>
        }
      />
    </div>
  );
}

export default OutletModuleType;

const outletModuleTypeColumns = (
  //   handleLeaveRequestView: (row: any) => void,
  handleEditOutletModuleType: (row: any) => void
) => [
  {
    name: "Module Name",
    selector: (row: { ModuleName: string }) => row.ModuleName ?? "-",
    sortable: true,
    // minWidth: "180px",
  },
  {
    name: "Actions",
    width: "200px",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          onClick={() => handleEditOutletModuleType(row)}
          className="btn d-flex align-items-center justify-content-center gap-1"
          style={{
            backgroundColor: "#43bab2",
            color: "white",
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            border: "none",
          }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
  },
];
